import React, { Component } from 'react';
import { connect } from 'react-redux';
import { userSelector, rankSelector } from "../redux/selectors";
import { Row, Col } from 'react-bootstrap';
import Moment from 'react-moment';
import Username from "../common/Username";
import ResourceContributionForm from './ResourceContributionForm';


class ResourceContributionItem extends Component {
    render() {
        if (!this.props.edit) {
            return (
                <Row>
                    <Col md={2}><Username user={this.props.users[this.props.contrib.userDetail]} rank={this.props.ranks[this.props.users[this.props.contrib.userDetail].rank]} /></Col>
                    <Col md={2}>{this.props.contrib.amount}</Col>
                    <Col md={2}>{this.props.contrib.description}</Col>
                    <Col md={2}><Moment fromNow>{this.props.contrib.created}</Moment></Col>
                </Row>

            )
        } else {
            return (
                <ResourceContributionForm 
                    form={this.props.contrib.id + '-ResourceContributionForm'} 
                    editToggle={this.props.editToggle} 
                    onSubmit={this.props.onSubmit} 
                    initialValues={{
                        user: this.props.contrib.user, 
                        amount: this.props.contrib.amount, 
                        dkp:0, 
                        id: this.props.contrib.id, 
                        chapter:this.props.chapter, 
                        section: this.props.section,
                        resource: this.props.resource
                    }} 
                    />
            )
        }
    }
}

const mapStateToProps = (state) => ({
    users: userSelector(state),
    ranks: rankSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ResourceContributionItem);



// WEBPACK FOOTER //
// ./src/Officer/ResourceContributionItem.js